import { render } from "./MsgItem.vue?vue&type=template&id=d3b972f4&scoped=true"
import script from "./MsgItem.vue?vue&type=script&lang=js"
export * from "./MsgItem.vue?vue&type=script&lang=js"

import "./MsgItem.vue?vue&type=style&index=0&id=d3b972f4&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b972f4"]])

export default __exports__